import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchUsers, setUserRole, suspendUser, deleteUser } from '../../actions/userAdminActions';

const ROLES = ['customer', 'cleaner', 'dispatcher', 'manager', 'admin'];

export default function AdminUsers() {
  const dispatch = useDispatch();
  const { items, total, loading } = useSelector(s => s.usersAdmin);
  const me = useSelector(s => s.auth.user);
  const [q, setQ] = useState('');
  const [filter, setFilter] = useState({ role: '', suspended: '' });

  useEffect(() => { dispatch(fetchUsers({ q, ...filter })); }, [dispatch, q, filter]);

  const changeRole = async (u, role) => {
    if (u.role === role) return;
    await dispatch(setUserRole(u._id, role));
  };
  const toggleSuspend = async (u) => {
    const reason = !u.suspended ? prompt('Reason for suspension (optional):') : null;
    await dispatch(suspendUser(u._id, !u.suspended, reason));
  };
  const remove = async (u) => {
    if (!confirm(`Delete ${u.email}? This is soft-delete; data is kept.`)) return;
    await dispatch(deleteUser(u._id));
  };

  return (
    <section className="section">
      <div className="section-head">
        <h1>Users <span className="muted" style={{fontWeight:400,fontSize:'1rem'}}>({total})</span></h1>
        <Link to="/admin/invites" className="btn-primary">Invite users →</Link>
      </div>

      <div className="filters">
        <input placeholder="Search by name, email, username" value={q} onChange={e => setQ(e.target.value)} />
        <select value={filter.role} onChange={e => setFilter({...filter, role: e.target.value})}>
          <option value="">Any role</option>
          {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
        <select value={filter.suspended} onChange={e => setFilter({...filter, suspended: e.target.value})}>
          <option value="">Any status</option>
          <option value="false">Active</option>
          <option value="true">Suspended</option>
        </select>
      </div>

      <table className="data-table">
        <thead>
          <tr>
            <th>Email</th><th>Name</th><th>Role</th><th>Status</th><th>Joined</th><th style={{textAlign:'right'}}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading && <tr><td colSpan="6" className="muted">Loading…</td></tr>}
          {!loading && items.length === 0 && <tr><td colSpan="6" className="muted">No users match.</td></tr>}
          {items.map(u => (
            <tr key={u._id}>
              <td>{u.email}{u.username ? <div className="muted" style={{fontSize:'.8rem'}}>@{u.username}</div> : null}</td>
              <td>{u.name || '—'}</td>
              <td>
                <select value={u.role} disabled={me && u._id === me._id} onChange={e => changeRole(u, e.target.value)}>
                  {ROLES.map(r => <option key={r} value={r}>{r}</option>)}
                </select>
              </td>
              <td>
                {u.suspended
                  ? <span style={{color:'#b53b3b',fontWeight:700}}>Suspended</span>
                  : <span style={{color:'#1a7a32',fontWeight:700}}>Active</span>}
              </td>
              <td>{new Date(u.createdAt).toLocaleDateString()}</td>
              <td style={{textAlign:'right'}}>
                <button className="btn-ghost" style={{marginRight:'.4rem',padding:'.3rem .7rem'}} onClick={() => toggleSuspend(u)} disabled={me && u._id === me._id}>{u.suspended ? 'Unsuspend' : 'Suspend'}</button>
                <button onClick={() => remove(u)} disabled={me && u._id === me._id} style={{padding:'.3rem .7rem',border:'1.5px solid #f0c4c4',background:'white',color:'#b53b3b',borderRadius:'6px',cursor:'pointer',fontWeight:600,fontSize:'.85rem'}}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
